
import Vue, { PropType } from 'vue'
import { Row, Action } from './types'
import RButton from '@/components/forms/RButton.vue'

export default Vue.extend({
  name: 'RTable',
  components: { RButton },
  props: {
    header: Array as PropType<string[]>,
    rows: Array as PropType<Row[]>,
    spacing: String,
    actions: Array as PropType<Action[]>,
  },
})
